module.exports = __webpack_public_path__ + "static/65-51042bd13fd3c1cba079eafb84979605.png";